/* eslint-disable react/function-component-definition */
import React from 'react';
import { Route } from 'react-router-dom';
import PrivateRoute from '../../../PrivateRoute';
import EsimLandingPage from '../pages/EsimLandingPage/EsimLandingPage';
import EsimPlansPage from '../pages/EsimPlansPage/EsimPlansPage';
import EsimBookingPage from '../pages/EsimBookingPage/EsimBookingPage';
import EsimVoucherPage from '../pages/EsimVoucherPage/EsimVoucherPage';
import { ESIM_ROUTES } from '../constants/esimConstants';

/**
 * Self-contained route fragment for the eSIM module.
 *
 * Usage from /src/AppRoutes.jsx:
 *
 *   import EsimRoutes from './features/esim/routes/EsimRoutes';
 *   ...
 *   <Routes>
 *     ...existing routes
 *     {EsimRoutes()}
 *   </Routes>
 */
const EsimRoutes = () => (
  <>
    <Route
      path={ESIM_ROUTES.LANDING}
      element={
        <PrivateRoute>
          <EsimLandingPage />
        </PrivateRoute>
      }
    />
    <Route
      path={ESIM_ROUTES.PLANS}
      element={
        <PrivateRoute>
          <EsimPlansPage />
        </PrivateRoute>
      }
    />
    <Route
      path={ESIM_ROUTES.BOOKING}
      element={
        <PrivateRoute>
          <EsimBookingPage />
        </PrivateRoute>
      }
    />
    <Route
      path={ESIM_ROUTES.VOUCHER}
      element={
        <PrivateRoute>
          <EsimVoucherPage />
        </PrivateRoute>
      }
    />
  </>
);

export default EsimRoutes;
